// ABOUTME: Loads the job types the caller can see (GET /api/job/types): args schema, schedulability
// ABOUTME: and what the caller may do with each. Indexed by type name for the permission checks.

import { useEffect, useMemo, useState } from 'react';

import { listJobTypes } from '../../api/jobApi';
import { JobTypeProjection } from '../../types';

export type JobTypesByName = Record<string, JobTypeProjection>;

export function useJobTypes() {
    const [types, setTypes] = useState<JobTypeProjection[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let active = true;
        listJobTypes()
            .then(data => {
                if (active) setTypes(data?.types ?? []);
            })
            .catch(e => {
                if (active) setError(e instanceof Error ? e.message : String(e));
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    const byType = useMemo<JobTypesByName>(
        () => Object.fromEntries(types.map(type => [type.type, type])),
        [types],
    );

    return { types, byType, loading, error };
}
